import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore('breadcrumbs', {
  state: () => ({
    labels: {} as Record<string, string>
  }),
  actions: {
    setLabel(key: string, label: string) {
      if (!key) return
      this.labels[key] = label
    },
    clearLabel(key: string) {
      if (!key) return
      delete this.labels[key]
    }
  }
})
